
export const bookingEntryStyle = {
  icon: {
    color: "#000",
  },
};
